import {forwardRef} from 'react';
import Textarea from './Textarea';

export default forwardRef(Textarea);
